import React, { useEffect, useState, useRef } from 'react';
import { useTimeout } from '@hooks/useTimeout';
import * as Styled from './ToastStyles';
import { ToastPropsInterface } from './ToastTypes';

function Toast({
  title,
  message,
  slug = 'default',
  severity = 'success',
  isShow,
  onClose,
  onOpen,
}: ToastPropsInterface) {
  const toastDataDefault: ToastPropsInterface = {
    isShow: false,
    title: '',
    slug: 'default',
    severity: 'neutral',
  };
  const [toastData, setToastData] = useState<ToastPropsInterface>({
    ...toastDataDefault,
  });
  const addTimeout = useTimeout();
  const toastDebounceRef = useRef<NodeJS.Timeout>();
  const toastRefConfirmation = useRef<HTMLFuelToastElement>(null);
  const timeFinishTransition = 100;

  function resetToast() {
    setToastData(toastDataDefault);
  }

  function handleToast() {
    resetToast();

    addTimeout(() => {
      setToastData({
        isShow,
        title,
        slug,
        message,
        severity,
      });
    }, 0);
  }

  useEffect(() => {
    if (toastData.message || toastData.title) {
      if (toastRefConfirmation.current) {
        toastRefConfirmation.current.open();

        if (toastDebounceRef.current) {
          clearTimeout(toastDebounceRef.current);
        }

        toastDebounceRef.current = addTimeout(() => {
          if (toastRefConfirmation?.current) {
            toastRefConfirmation.current.close();
          }
        }, 4500);
      }
    }
  }, [toastData.message, toastData.title]);

  useEffect(() => {
    if (isShow) {
      handleToast();
    }
  }, [isShow, message, title]);

  return (
    <div>
      {(toastData.message || toastData.title) && (
        <Styled.CustomFuelToast
          slug={slug}
          ref={toastRefConfirmation}
          heading={title}
          message={message}
          severity={severity}
          onFuel-toast-open={() => onOpen && onOpen()}
          onFuel-toast-close={() => {
            addTimeout(() => {
              if (onClose) {
                onClose();
              }
            }, timeFinishTransition);
          }}
        />
      )}
    </div>
  );
}

export default Toast;
